import React from 'react';
import dayjs from 'dayjs';
import Select from "react-select";
import DataTableSarang from '../../../components/datatable-sarang';
import FormSearchWrapperSarang from '../../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';
import headCellsListCuisineOrder from '../head-cell-list-cuisine-order';
import { optionsCuisineOrderStatus, optionsReceiptTime } from '../../../common/constant';
import tickIcon from "../../../assets/icon/tick.png";
import cancelIcon from "../../../assets/icon/cancel.png";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";

const CuisineOrderTable = ({
    isTabletOrMobile,
    openSearch,
    setOpenSearch,
    openAddDialog,
    renderFormSearch,
    sumaryCuisine,
    rowsPerPage,
    handleChangeRowsPerPage,
    handleRequestSort,
    order,
    orderBy,
    totalItemCount,
    setRowsPerPage,
    page,
    handleChangePage,
    configLocal,
    getListCuisineOrderManagement,
    searchData,
    data,
    receiptTimeOrder,
    setOpenChangeStatusDialog,
    openConfirmDialog,
    setOpenChangeConfirmDialog,
    setOpenDeleteDialog,
    openEditDialog
}) => {
    return (
        <>
            <FormSearchWrapperSarang
                isTabletOrMobile={isTabletOrMobile} openSearch={openSearch} setOpenSearch={setOpenSearch} openAddDialog={openAddDialog}
            >
                {renderFormSearch()}
            </FormSearchWrapperSarang>
            <DataTableSarang
                sumary={sumaryCuisine}
                rowsPerPage={rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                headCells={headCellsListCuisineOrder}
                handleRequestSort={handleRequestSort}
                order={order}
                orderBy={orderBy}
                totalItemCount={totalItemCount}
                setRowsPerPage={setRowsPerPage}
                pageIndex={page}
                handleChangePage={handleChangePage}
                configLocal={configLocal}
                getList={getListCuisineOrderManagement}
                searchData={searchData}
            >
                <tbody>
                    {
                        data.length > 0 ?
                            data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td><span>{row.orderCode}</span></td>
                                    <td><span className={row.receiptTime === 2 ? "text-primary" : "text-danger"} >{dayjs(row.orderDate).format("DD/MM/YYYY")}</span></td>
                                    <td><span className={row.receiptTime === 2 ? "text-primary" : "text-danger"} >{optionsReceiptTime.find(item => item.value === row.receiptTime)?.label}</span></td>
                                    <td><span>{row.quatity}</span></td>
                                    <td><span>{row.herdsManOrderName}</span></td>
                                    <td><span><a href={`tel:${row.herdsManOrderPhoneNumber}`}>{row.herdsManOrderPhoneNumber}</a></span></td>
                                    <td><span>{row.deliveryType === 0 ? "Giao nhận" : row.deliveryType === 1 ? "Tự lấy" : "Ăn tại nhà hàng"}</span></td>
                                    <td><span>{row.address}</span></td>
                                    <td>
                                        {
                                            (!row.allowChangeStatus) ? <span>{row.orderStatusName}</span> :
                                                <span>
                                                    <Select
                                                        value={row?.orderStatus ? { label: row.orderStatusName, value: row.orderStatus } : null}
                                                        placeholder="Chọn Trạng thái"
                                                        onChange={(data) => {
                                                            setOpenChangeStatusDialog(true);
                                                            openConfirmDialog({ ...row, orderStatusChange: data.value, orderStatusNameChange: data.label });
                                                        }}
                                                        options={optionsCuisineOrderStatus.filter(x => ((x.value === 30 || x.value >= 50) && x.value !== row.orderStatus) && x.value >= row?.orderStatus)}
                                                        noOptionsMessage={() => "Không tồn tại"}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                    />
                                                </span>
                                        }
                                    </td>
                                    <td>
                                        <span>
                                            {
                                                row.orderStatus >= 20 ?
                                                    (
                                                        <img title="Đã xác nhận" src={tickIcon} alt="Tick" />
                                                    ) : (
                                                        <img title="Chưa xác nhận" style={{ cursor: 'pointer' }}
                                                            src={cancelIcon}
                                                            alt="Cancel" onClick={() => {
                                                                if (row.allowConfirm) {
                                                                    setOpenChangeConfirmDialog(true);
                                                                    openConfirmDialog(row);
                                                                }
                                                                else {
                                                                    ShowNotification("Ae/Ce không có quyền xác nhận", NotificationMessageType.Warning);
                                                                }
                                                            }}
                                                        />
                                                    )}
                                        </span>
                                    </td>
                                    <td>
                                        <span>{row.herdsManConfirmName}</span>
                                    </td>
                                    <td>
                                        {
                                            row.herdsmanDeliveryName ?
                                                <span>{row.herdsmanDeliveryName}
                                                    {
                                                        row.herdsmanDeliveryPhone ? <> (<a href={`tel:${row.herdsmanDeliveryPhone}`}>{row.herdsmanDeliveryPhone})</a></> : <></>
                                                    }
                                                </span> :
                                                <span style={{ width: "100%", display: "inline-block", textAlign: "center" }}>
                                                    --
                                                </span>
                                        }
                                    </td>
                                    <td><span>{row.description}</span></td>
                                    <td>
                                        {row.allowEdit &&
                                            <div className='d-flex'>
                                                <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table edit" data-toggle="tooltip" data-placement="top"
                                                    title="Sửa"
                                                    onClick={() => { openEditDialog(row) }}
                                                >
                                                    <i className="far fa-edit"></i>
                                                </button>
                                                <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table delete" data-toggle="tooltip" data-placement="top"
                                                    title="Xóa"
                                                    onClick={() => {
                                                        setOpenDeleteDialog(true);
                                                        openConfirmDialog(row);
                                                    }}
                                                >
                                                    <i className="far fa-trash-alt"></i>
                                                </button>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            )) :
                            <tr><td colSpan={14}>Chưa có dữ liệu</td></tr>
                    }
                </tbody>
            </DataTableSarang>
        </>
    );
};

export default CuisineOrderTable;
